<script setup lang="ts">
import { DigitalGiftRecipient } from '@/utils/cart';

const props = withDefaults(
  defineProps<{
    editable: boolean;
    isEditing?: boolean;
    preview?: boolean;
    recipient: DigitalGiftRecipient;
    recipientNumber: number;
  }>(),
  {
    editable: true,
  },
);

const emit = defineEmits(['edit-recipient', 'open-preview-ecard']);

const handleEditClick = () => emit('edit-recipient', props.recipientNumber);
const handleOpenPreviewEcard = () => emit('open-preview-ecard', props.recipient);
</script>

<template>
  <div data-test="digital-gifting-saved-recipient">
    <div class="w-full">
      <div
        class="flex content-center justify-between mb-2"
        data-test="digital-gifting-saved-recipient-label"
      >
        <strong class="text-sm md:text-base">Recipient {{ recipientNumber }}:</strong>
        <div class="flex text-xs md:text-sm">
          <div
            v-if="editable"
            class="underline cursor-pointer"
            @click="handleEditClick"
            @keydown.enter="handleEditClick"
            tabindex="0"
          >
            Edit
          </div>
          <div
            v-if="preview"
            class="ml-4 underline cursor-pointer"
            @click="handleOpenPreviewEcard"
            @keydown.enter="handleOpenPreviewEcard"
            :tabindex="isEditing ? -1 : 0"
          >
            Preview eCard
          </div>
        </div>
      </div>
      <div
        class="text-sm text-left md:text-base hyphens"
        data-test="digital-gifting-saved-recipient-info"
      >
        <div>{{ recipient.name }}</div>
        <div>{{ recipient.email }}</div>
        <div>{{ recipient.message }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hyphens {
  hyphens: auto;
}
</style>
